import { useContext } from 'react';
import { DiscordContext } from './DiscordContext';

/**
 * Hook for consuming Discord Activity context.
 *
 * Returns the same shape as DiscordContext's default value plus
 * whatever the SDK has populated. Safe to call from any component
 * — outside the provider it returns the default value, which has
 * isEmbedded: false.
 */
export function useDiscord() {
    return useContext(DiscordContext);
}
